module.exports = __webpack_public_path__ + "img/curso-online.4bc5beb7.svg";